// Analytics tab. There is one workspace, so this is a pass-through to the
// invoice dashboard: the workspace button row it used to carry was a one-option
// control and is deleted (docs/app.md §2 — "no dead toggles"). The tab stays
// its own file so a second workspace later has somewhere to branch.
//
// Subheader only (owner item 12, 2026-08-13): `DashboardScreen.tsx` renders
// its own `<ScreenTitle>Analytics</ScreenTitle>` and is a different
// workstream's file, so the subheader below renders ABOVE that title rather
// than tucked under it — a known layout gap tracked for whoever next touches
// `DashboardScreen.tsx`'s header, not a placeholder: the text itself is the
// real, approved sentence, read from `SCREEN_SUBHEADER` like every other
// screen's.
import { Body1, makeStyles, tokens } from '@fluentui/react-components'
import type { Session } from '../lib/identity'
import { SCREEN_SUBHEADER } from '../lib/constants'
import { DashboardScreen } from './DashboardScreen'

const useStyles = makeStyles({
  sub: { color: tokens.colorNeutralForeground3, display: 'block', marginBottom: '10px' },
})

interface Props {
  session: Session
  refreshNonce?: number
}

export function AnalyticsScreen({ session, refreshNonce }: Props) {
  const s = useStyles()
  return (
    <>
      <Body1 className={s.sub}>{SCREEN_SUBHEADER.Analytics}</Body1>
      <DashboardScreen session={session} refreshNonce={refreshNonce} />
    </>
  )
}
